export const API_GROUP_URL = `${process.env.REACT_APP_BEIN_API}/group/` || '';
export const API_ADMIN_URL = API_GROUP_URL + 'admin';
export const API_USER_URL = `${process.env.REACT_APP_BEIN_API}/user/` || '';
export const API_USER_ADMIN_URL = API_USER_URL + 'admin';

export const FAILED_COUNT_LIMIT = 3;
